import { degreeChart } from '@/lib/degree_chart';

/**
 * アルファベット表記のコードからルート音を抽出する
 * @param alphabetChord アルファベット表記のコード
 */
export const extractAlphabetRoot = (alphabetChord: string): string => {
  const regexp = /^([ABCDEFG][#b]?)/;
  const alphabet = regexp.exec(alphabetChord);
  return alphabet === null ? '' : alphabet[1];
};

/**
 * アルファベット表記のコードからオンコードのルート音を抽出する
 * @param alphabetChord アルファベット表記のコード
 */
export const extractAlphabetOnChordRoot = (alphabetChord: string): string => {
  const regexp = /\/([A-G][#b]?)$/;
  const alphabet = regexp.exec(alphabetChord);
  return alphabet === null ? '' : alphabet[1];
};

/**
 * アルファベット表記のコードからダイアトニックコードを抽出する
 * @param alphabetChord アルファベット表記のコード
 */
export const extractDiatonicChord = (alphabetChord: string): string => {
  const regexp = /^([ABCDEFG][#b]?m?)/;
  const diatonicChord = regexp.exec(alphabetChord);
  return diatonicChord === null ? '' : diatonicChord[1];
};

/**
 * 度数表記のコードからルート音を抽出する
 * @param degreeChord 分数表記のコード
 */
export const extractDegreeRoot = (degreeChord: string): string => {
  const regexp = /^([1234567][#b]?)/;
  const degree = regexp.exec(degreeChord);
  return degree === null ? '' : degree[1];
};

/**
 * 度数表記のコードからオンコードのルート音を抽出する
 * @param degreeChord 分数表記のコード
 */
export const extractDegreeOnChordRoot = (degreeChord: string): string => {
  const regexp = /\/([1234567][#b]?)$/;
  const degree = regexp.exec(degreeChord);
  return degree === null ? '' : degree[1];
};

/**
 * アルファベット表記のコードを度数表記に変換する
 * @param key フレーズのキー
 * @param alphabetChord アルファベット表記のコード
 */
export const convertToDegree = (key: string, alphabetChord: string): string => {
  const alphabetRoot = extractAlphabetRoot(alphabetChord);
  const degreeRoot = degreeChart[key][alphabetRoot];
  if (typeof degreeRoot === 'undefined') {
    return '?';
  }
  let result = alphabetChord.replace(alphabetRoot, degreeRoot);

  const alphabetOnChordRoot = extractAlphabetOnChordRoot(alphabetChord);
  if (alphabetOnChordRoot) {
    const degreeOnChordRoot = degreeChart[key][alphabetOnChordRoot];
    result = result.replace(alphabetOnChordRoot, degreeOnChordRoot);
  }

  return result;
};

/**
 * 度数表記のコードをアルファベット表記に変換する
 * @param key フレーズのキー
 * @param degreeChord 度数表記のコード
 */
export const convertToAlphabet = (key: string, degreeChord: string) => {
  const degreeRoot = extractDegreeRoot(degreeChord);
  const alphabetRoot = Object.keys(degreeChart[key]).find((root) => {
    return degreeChart[key][root] === degreeRoot;
  });
  if (!alphabetRoot) {
    return '?';
  }
  let result = degreeChord.replace(degreeRoot, alphabetRoot);

  const degreeOnChordRoot = extractDegreeOnChordRoot(degreeChord);
  if (degreeOnChordRoot) {
    const alphabetOnChordRoot = Object.keys(degreeChart[key]).find((root) => {
      return degreeChart[key][root] === degreeOnChordRoot;
    });
    if (!alphabetOnChordRoot) {
      return '?';
    }

    result = result.replace(degreeOnChordRoot, alphabetOnChordRoot);
  }

  return result;
};
